import { useContext } from "react";

import { isPresent } from "neetocist";
import { joinHyphenCase } from "neetocommons/utils/general";
import { Typography } from "neetoui";
import { useTranslation } from "react-i18next";

import { HOUR_FORMATS } from "./constants";
import ScheduleContext from "./ScheduleContext";
import { convert24hTo12h, sortDays, sortPeriodsByKey } from "./utils";

const DisplayAvailability = ({ periods }) => {
  const { t } = useTranslation();
  const { firstDay, hourFormat } = useContext(ScheduleContext);

  const formatHour = hour => {
    if (hourFormat === HOUR_FORMATS.H24) {
      return hour;
    }

    return convert24hTo12h(hour);
  };

  return (
    <div className="flex w-full flex-col gap-y-3">
      {sortDays(firstDay).map(day => (
        <div
          className="neeto-ui-rounded-md neeto-ui-border-gray-300 neeto-ui-bg-white flex w-full flex-wrap items-center justify-center gap-2 border px-6 py-4 sm:items-start sm:justify-start"
          data-testid={`day-cards-${day}`}
          key={day}
        >
          <Typography
            className="mt-0.5 w-24 text-center sm:w-1/4 sm:text-start"
            data-testid={joinHyphenCase(day, "day-text")}
            style="h5"
            weight="semibold"
          >
            {t(`neetoMolecules.schedule.days.${day}`)}
          </Typography>
          <div className="flex flex-grow flex-col items-center gap-y-4 sm:w-1/2">
            {isPresent(periods[day]) ? (
              sortPeriodsByKey({
                periods: periods[day],
                key: "startTime",
                order: "asc",
              })?.map(period => (
                <div className="flex items-center gap-x-4" key={period.id}>
                  <Typography
                    className="w-20 text-end"
                    lineHeight="relaxed"
                    style="h5"
                    weight="semibold"
                    data-testid={joinHyphenCase(
                      day,
                      period.startTime,
                      "start-time-text"
                    )}
                  >
                    {formatHour(period.startTime)}
                  </Typography>
                  <Typography
                    className="neeto-ui-text-gray-600"
                    component="span"
                  >
                    -
                  </Typography>
                  <Typography
                    className="w-20 text-start"
                    lineHeight="relaxed"
                    style="h5"
                    weight="semibold"
                    data-testid={joinHyphenCase(
                      day,
                      period.endTime,
                      "start-time-text"
                    )}
                  >
                    {formatHour(period.endTime)}
                  </Typography>
                </div>
              ))
            ) : (
              <Typography
                className="mx-8 flex-grow text-center"
                data-testid={joinHyphenCase(day, "unavailable-time-text")}
                lineHeight="relaxed"
                style="h5"
              >
                {t("neetoMolecules.schedule.unavailable")}
              </Typography>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default DisplayAvailability;
